import React, { useEffect, useRef } from 'react'
import { useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import HomeVideo from '../../assets/images/check-video.mp4';

export default function SDLC() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <section className="inner-banner" style={{ position: 'relative', overflow: 'hidden' }}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                    }}
                >
                    <source src={HomeVideo} type="video/mp4" />
                </video>
                <h1 className='heading'>SDLC Consulting</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link to="#">Home</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item active" aria-current="page">SDLC Consulting</li>
                    </ol>
                </nav>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='header-title mb-40px'>
                                <h3 className='heading wow fadeInUp' >SDLC consulting</h3>
                                <p className='paragraph'>Our service provides comprehensive software development lifecycle (SDLC) consulting, helping businesses refine each phase of their development processes. From planning and design to implementation, testing, and maintenance, we focus on optimizing workflows, adopting best practices, and leveraging the latest tools. This approach not only enhances efficiency but also drives improved outcomes and accelerates time to market.
                                </p>
                                <p className='paragraph wow fadeInUp'>
                                    Optimize SDLC phases, embrace Agile, utilize CI/CD, measure performance, engage stakeholders, manage risks, and invest in team training.
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='service-left-image' style={{ backgroundColor: '#ffff', borderRadius: '50px' }}>
                                <img src={require('../../assets/images/services/sdlc.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                    <div className="row top">
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/depth-perception.webp')} alt="anytime" />
                                <h2>Depth</h2>
                                <p>Our hackers go in depth to find vulnerabilities in your system.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/service.webp')} alt="Mobile Application Development" />
                                <h2>Standards</h2>
                                <p>We use industry standard tools to find even the bad loopholes.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/receipt.webp')} alt="Mobile App Development Services " />
                                <h2>Report</h2>
                                <p>Get a penetration testing report that's written in layman language.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/comment.webp')} alt="Mobile App Development Services " />
                                <h2>Good News</h2>
                                <p>Yes, your free consultation is just a click away.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom' style={{ background: '#101218' }}>
                <div className='container'>
                    <div className="row">
                        <div className='col-lg-6'>
                            <p className='paragraph wow fadeInUp'>
                                Cyber Fortify’s software development lifecycle consulting service helps businesses streamline their development processes and enhance efficiency.
                                Our expert team works closely with clients to evaluate their current practices, identify gaps, and provide customized solutions that align with their unique needs.
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p className='paragraph wow fadeInUp'>
                                At Cyber Fortify, we specialize in optimizing the entire software development lifecycle—from ideation to deployment—to help businesses meet their development objectives.
                                Our approach is flexible, collaborative, and customized to address the specific needs of each client, ensuring effective solutions that drive success.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className='header-title'>
                            <h2 className='heading wow fadeInUp'>Here are some of the services we offer for software development lifecycle consulting</h2>
                        </div>
                        <div className='col-lg-6'>
                            <p className='paragraph wow fadeInUp'>
                                Assessment of current software development processes.<br />
                                Design and implementation of streamlined software development processes.<br />
                                Ongoing maintenance and support for software development processes.<br />
                                Evaluation and selection of software development tools and platforms
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p className='paragraph wow fadeInUp'>
                                Analysis of software development requirements and bottlenecks.<br />
                                Documentation and training for software development processes<br />
                                Integration with other systems and tools for seamless software development processes
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            <section className='more-services mb-0' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='header-title mb-40px top'>
                                <h3 className='heading wow fadeInUp' >SDLC Consulting as a Service</h3>
                                <p className='paragraph'>Our team of consultants brings extensive experience in software development and a comprehensive understanding of the latest tools and technologies. Through our software development lifecycle consulting services, we empower businesses to optimize their development processes, reduce costs, and accelerate time-to-market.</p>
                            </div>
                        </div>
                        <div className='col-lg-6 mb-40px top service-more-detials'>
                            <div className="cards">
                                <div className='box-text'>
                                    <h4 className='heading'>Explore More Services</h4>
                                    <p className='paragraph'>"Discover comprehensive cybersecurity solutions to safeguard your digital assets today."</p>
                                    <div className='services-button'>
                                        <Link to="/services">
                                            <button className='btn footer-btn btn-class'>More Services<span>More Services</span></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </section>

            <section className='faq-section-b bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <h2 className='heading text-center text-dark' style={{ fontWeight: 'bold' }}>Frequently Asked Questions</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='service-detail-left-side'>
                                <div className='faq-section-inner'>
                                    <div class="accordion wow fadeInUp" id="accordionExample">
                                        <div className='faq-box'>

                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        How does consumer marketing differ from other forms of marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Consumer marketing focuses specifically on understanding and targeting individual consumers, whereas other forms of marketing may target businesses or broader market segments.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        What strategies does Brand Street use to engage consumers?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We utilize a variety of strategies including targeted messaging, personalized experiences, influencer partnerships, and interactive content to engage consumers and drive brand affinity.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        How does Brand Street ensure that its consumer marketing campaigns resonate with target audiences?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We conduct thorough audience research and employ data-driven insights to tailor our campaigns to the unique preferences and behaviors of our target audience.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        Can Brand Street help with both B2C and B2B consumer marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Yes, we have experience working with clients in both B2C and B2B industries, developing customized strategies to effectively reach and engage their respective target audiences.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        What types of consumer marketing channels does Brand Street utilize?
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We leverage a mix of traditional and digital channels including social media, email marketing, content marketing, experiential activations, and influencer partnerships to reach and engage consumers across multiple touchpoints.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
